var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-card-list__item"},[(!_vm.item.ContactsCallCenter)?_c('contact-item-v1',{attrs:{"item":_vm.item}}):_c('contact-item-v2',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./Scripts/app/FooterContactInfo/ContactCardItemSelector.vue